export default __webpack_public_path__ + "static/media/Inter-Bold.df60e0aa.woff2";